export interface INichesState {
  niches: any;
  loading: boolean;
  error: Error | null;
}

const defaultState = {
  niches: [],
  loading: false,
  error: null
};

export const getDefaultNichesState = () => defaultState;
